<template>
  <div class="">
    <insurance-payments></insurance-payments>
  </div>
</template>

<script>
import InsurancePayments from "@/components/insurance-payments/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    InsurancePayments,
  },

  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Quietanzamento",
        path: "insurance-payments.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Quietanzamento",
        path: "insurance-payments.edit",
        level: 3,
      });
    }
  },
};
</script>
